<div class="page-div">
    <div class="pageHeader">Trial Balance Results</div>  
    <div class="main-label" *ngIf="moneyTable.length !=0 || stringTable.length != 0">Of the loan attributes entered only the following attributes were found to differ:</div>
    <div class="main-label"*ngIf="moneyTable.length ==0 && stringTable.length == 0">Of the loan attributes entered none were found to differ.</div>
    <div *ngIf="moneyTable.length !=0" class="u-scroll-x">
        <fm-table [columns]="mcols" [value]="moneyTable">
            <ng-template fmTemplate="header" let-columns>
                <tr>
                    <th *ngFor="let col of columns"><span class="data-label">{{col.header}}</span></th>
                </tr>
            </ng-template>
            <ng-template fmTemplate="body" let-rowData let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns">
                        <span *ngIf="col.field === 'label'" class="data-label">{{rowData[col.field]}}</span>
                        <span *ngIf="(col.field === 'userValue' || (col.field === 'fmValue' && rowData['fmValue'] !== '--' )) && rowData['label'] !== 'Term'">{{rowData[col.field] | currency}}</span>
                        <span *ngIf="col.field === 'diffValue' || (col.field !== 'label' && rowData['label'] === 'Term') || (col.field === 'fmValue' && rowData['fmValue'] === '--' )">{{rowData[col.field]}}</span>
                    </td>
                </tr>
            </ng-template>
        </fm-table>
    </div>
    <div><hr class="trial-hr-style"></div>
    <div *ngIf="stringTable.length !=0" class="u-scroll-x">
        <fm-table [columns]="scols" [value]="stringTable">
            <ng-template fmTemplate="header" let-columns>
                <tr>
                    <th *ngFor="let col of columns"><span class="data-label">{{col.header}}</span></th>
                </tr>
            </ng-template>
            <ng-template fmTemplate="body" let-rowData let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns">
                        <span [ngClass] = "col.field === 'label' ? 'data-label' : ''">{{rowData[col.field]}}</span>
                    </td>
                </tr>
            </ng-template>
        </fm-table>
        </div>
        <div><hr class="trial-hr-style"></div>
        <div class="main-label">Loan Info:</div>
        <div class="sub-label">Loan Number:  {{loanNumber}}</div>
        <div class="sub-label">Reporting Period:  {{reportingPeriod}}</div>
</div>
 